<div
  [className]="
    getCardClass(data.category) +
    ' card card-custom m-2 d-flex align-items-center rounded-top pr-1 p-5 ' +
    (isPv ? 'cursor-pointer' : ' ')
  "
  (mouseleave)="mouseOut()"
>
  <div class="d-flex w-100">
    <div class="d-flex flex-column flex-grow-1" [ngStyle]="{ 'max-width': isPv ? '75%' : '75%' }">
      <div>
        <div class="d-flex flex-wrap">
          <div class="sig mr-2 cursor-pointer font-weight-bolder text-dark">
            Title : {{ data?.title }}
          </div>
        </div>
        <!--        <div-->
        <!--          [matTooltip]="getDrugDetails(card).replace('<div>','').replace('<b>','').replace('</b>','').replace('</div>','')"-->
        <!--          class="hhh prescription" [innerHTML]="getDrugDetails(card) | safe: 'html'"></div>-->
        <div class="d-flex flex-wrap">
          <div *ngIf="!isPv" class="hhh prescription pr-3 font-weight-bolder text-dark">
            Medication: {{ getMedication(data.drug_code) }}
          </div>
        </div>

        <ng-container>
          <div class="hhh prescription">
            <p>Text: {{ data.text }}</p>
          </div>
        </ng-container>
      </div>

      <div style="position: absolute; right: 0; bottom: 0; display: flex">
        <!--      <span class=""-->
        <!--            [matTooltip]="getBadgeTooltip()"-->
        <!--            [ngClass]="{'svg-icon-danger cursor-pointer z-index-1000': card.medication_errors && card.medication_errors.length>0,'svg-icon-warning': !(card.medication_error && card.medication_error.length>0) ,'svg-icon svg-icon-3x':true}"-->
        <!--            *ngIf="card.is_verify == '0'"-->
        <!--            style="display: flex;align-items: center; max-height: 30px;max-width: 30px"-->
        <!--            [inlineSVG]="'./assets/media/svg/icons/Code/Warning-2.svg'"></span>-->

        <!--      <span class="svg-icon svg-icon-3x svg-icon-warning" *ngIf="card.hold == '1'" [matTooltip]="card.hold_note"-->
        <!--            style="display: flex;align-items: center"><i-->
        <!--        class="far fa-pause-circle text-grey icon-2x"></i></span>-->
      </div>
    </div>
    <div style="width: 25%" *ngIf="isPv" class="d-flex">
      <!--      <div class="hhh prescription" [innerHTML]="getHoa(card) | safe: 'html'"></div>-->
      <!--      <div class="ml-3 pl-3">-->
      <!--        DAW: {{card.daw}}-->
      <!--      </div>-->
    </div>
    <div
      style="
        min-width: 24%;
        max-width: 25%;
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
      "
    >
      <div class="indicator indicator-very-blue" matTooltip="source" *ngIf="data.source">
        {{ data.source }}
      </div>
      <div
        class="indicator indicator-very-blue"
        matTooltip="problem_code"
        *ngIf="data.problem_code"
      >
        {{ data.problem_code }}
      </div>
      <div class="indicator indicator-very-blue" matTooltip="risk" *ngIf="data.risk">
        {{ data.risk }}
      </div>
    </div>
    <div class="d-flex flex-column">
      <div *ngIf="!isPv && statusKey !== 'resolved'">
        <i class="ki ki-more-ver icon-md cursor-pointer" (click)="mySelect.open()"></i>
        <mat-select class="hide-trigger" #mySelect style="height: 0">
          <mat-option
            (click)="manageProblem()"
            *ngIf="statusKey === 'potential' || statusKey === 'future_review'"
          >
            Manage Problem
          </mat-option>
          <mat-option
            (click)="ignore(data)"
            *ngIf="statusKey === 'potential' || statusKey === 'active'"
          >
            Ignore
          </mat-option>
          <mat-option
            (click)="pendProblem(data)"
            *ngIf="statusKey === 'potential' || statusKey === 'active'"
          >
            Review At Later Time
          </mat-option>
        </mat-select>
      </div>
      <div style="position: absolute; top: 45px; right: 12px">
        <span
          class="svg-icon svg-icon-secondary svg-icon-2x cursor-pointer"
          *ngIf="data.previous_managed_drp !== null"
          (click)="recurrentProblem(data)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect x="0" y="0" width="24" height="24" />
              <path
                d="M12,8 L8,8 C5.790861,8 4,9.790861 4,12 L4,13 C4,14.6568542 5.34314575,16 7,16 L7,18 C4.23857625,18 2,15.7614237 2,13 L2,12 C2,8.6862915 4.6862915,6 8,6 L12,6 L12,4.72799742 C12,4.62015048 12.0348702,4.51519416 12.0994077,4.42878885 C12.264656,4.2075478 12.5779675,4.16215674 12.7992086,4.32740507 L15.656242,6.46136716 C15.6951359,6.49041758 15.7295917,6.52497737 15.7585249,6.56395854 C15.9231063,6.78569617 15.876772,7.09886961 15.6550344,7.263451 L12.798001,9.3840407 C12.7118152,9.44801079 12.607332,9.48254921 12.5,9.48254921 C12.2238576,9.48254921 12,9.25869158 12,8.98254921 L12,8 Z"
                fill="#000000"
              />
              <path
                d="M12.0583175,16 L16,16 C18.209139,16 20,14.209139 20,12 L20,11 C20,9.34314575 18.6568542,8 17,8 L17,6 C19.7614237,6 22,8.23857625 22,11 L22,12 C22,15.3137085 19.3137085,18 16,18 L12.0583175,18 L12.0583175,18.9825492 C12.0583175,19.2586916 11.8344599,19.4825492 11.5583175,19.4825492 C11.4509855,19.4825492 11.3465023,19.4480108 11.2603165,19.3840407 L8.40328311,17.263451 C8.18154548,17.0988696 8.13521119,16.7856962 8.29979258,16.5639585 C8.32872576,16.5249774 8.36318164,16.4904176 8.40207551,16.4613672 L11.2591089,14.3274051 C11.48035,14.1621567 11.7936615,14.2075478 11.9589099,14.4287888 C12.0234473,14.5151942 12.0583175,14.6201505 12.0583175,14.7279974 L12.0583175,16 Z"
                fill="#000000"
                opacity="0.3"
              />
            </g>
          </svg>
        </span>
      </div>
    </div>
  </div>
</div>
